import { Component } from '@angular/core';
import { Environment } from 'src/app/models/environment';
import { EnvironmentService } from 'src/app/services/environment.service';

@Component({
    selector: 'app-oncall-home',
    templateUrl: './oncall-home.component.html',
    styleUrls: ['./oncall-home.component.css'],
    standalone: false
})
export class OnCallHomeComponent {
  environment: Environment;
  pageEnabled: boolean;
  constructor(
    private environmentService: EnvironmentService
  ) {
    this.environment = this.environmentService.getEnvironment();
    this.pageEnabled = this.environment.featureToggles.onCallEnabled === 'true';
  }
}
